import Icon from '../components/Icon.vue'

Icon.register({"caret-left":{"width":640,"height":1792,"paths":[{"d":"M640 448v896q0 26-19 45t-45 19-45-19l-448-448q-19-19-19-45t19-45l448-448q19-19 45-19t45 19 19 45z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/caret-left.js